import { BraintreePay } from "./site/braintree";
import { FormHelper } from "./site/formhelper";
import './site/refercookie';

declare global {
    interface Window {
        AJN: any;
    }
}

window.AJN = window.AJN || {};

window.AJN.site_js = {
    BraintreePay: BraintreePay,
    FormHelper: FormHelper,
};
